import { SectionProps } from 'contracts/section';
import photo2 from 'assets/images/photo2.jpg';
import photo3 from 'assets/images/photo3.jpg';
import photo4 from 'assets/images/photo4.jpg';
import photo5 from 'assets/images/photo5.jpg';
import photo6 from 'assets/images/photo6.jpg';

export const content: SectionProps[] = [
  {
    id: 1,
    position: 'left',
    image: photo2,
    title: 'Eclipse total',
    text: 'Com cantos arredondados e traços orgânicos, o delineador preto gráfico ganha uma roupagem moderna.',
    legend: 'Anel, Bea Bongiasca.',
  },
  {
    id: 2,
    position: 'full',
    image: photo3,
    title: 'Em camadas',
    text: `Para um efeito tridimensional, aposte em um lápis de olho com acabamento matificado. Essa textura, combinada a traços ágeis, dá o tom de “cisne negro”.`,
    legend: 'Anéis, Dior.',
  },
  {
    id: 3,
    position: 'right',
    image: photo4,
    title: 'solar power',
    text: `Um toque de cor faz a diferença, e os tons alaranjados e quentes saem na frente.`,
    legend: 'Casaco, Dior. Brinco, Bea Bongiasca.',
  },
  {
    id: 4,
    position: 'left',
    image: photo5,
    title: 'ao quadrado',
    text: `Os cílios inferiores desenhados à la Twiggy estão em alta. Traga-os para os dias de hoje ao complementar o look com um delineador duplo na pálpebra superior.`,
    legend: 'Brinco, Dior.',
  },
  {
    id: 5,
    position: 'right',
    image: photo6,
    title: 'Choque Índigo',
    text: `Aposte em um olho de gatinho com espessura turbinada e arremate o visual com uma cor de impacto, como o azul-cobalto.`,
    legend: 'Top, Richard Malone. Laçarote, acervo da stylist.',
  },
];
